/* A panel's resize handle (GH #2973): a thin hit area on the panel's left edge, centred on its border */
.separator {
  position: absolute;
  top: 0;
  left: -4px;
  width: 7px;
  height: 100%;
  cursor: col-resize;
  z-index: 2;
  touch-action: none;
}

/* The 2px line shows on hover, while dragging and on keyboard focus, as on the left sidebar */
.separator::after {
  content: '';
  position: absolute;
  left: 2px;
  top: 0;
  width: 2px;
  height: 100%;
}

.separator:hover::after,
.separator:active::after,
.separator:focus-visible::after {
  background-color: var(--tuna-palette-primary-main);
}

.separator:focus-visible {
  outline: 2px solid var(--tuna-focus-ring);
  outline-offset: -2px;
}

/*
 * A touch screen: a 24px hit area, mostly over the panel, so it overlaps only 6px of the document and doesn't catch a
 * scroll or tap meant for the page (Joni's review of #3015, P3 4). The line stays on the border.
 */
@media (pointer: coarse) {
  .separator {
    left: -6px;
    width: 24px;
  }

  .separator::after {
    left: 5px;
  }
}
